import { Fragment, useEffect, useMemo, useState } from "react";
import { useHistory } from "react-router-dom";
//--------------------------------------------------------------------------------------------
import { ReactComponent as Upload } from "src/img/svg/upload.svg";
import { ReactComponent as Download } from "src/img/svg/download.svg";
import Resize from "src/components/common/resize";
import magnifierImg from "src/img/magnifier.png";
import UserInfo from "src/components/common/userInfo";
import Footer from "src/components/common/frame/footer";
import { useMyStore } from "src/components/main/mainStore";
import Export from "./export";
import {
    myAxios,
    MyFormData,
    getTimeStamp,
    scroll,
    boolAndReducer,
    appTitle,
    getDriveFolderId,
} from "src/components/common/functions";
import Settings from "./settings";
import Yards from "./yards";
import Yard from "./yard";
import Inventory from "./inventory";
import Detail from "./detail";
import DataFilter from "src/components/common/frame/dataFilter";
import FleetForm from "./fleetForm";
import TransitionWidthHeight from "../common/TransitionWidthHeight";
//--------------------------------------------------------------------------------------------
export default function Fleets({ tabTitle }){
    const pathKeys = useMemo(() => ["Yard", "Yards", "Settings", "Inventory", "Add", ""], []);
    const dataFrame = [
        {label: "Truck Number", key: "truckNumber"}, 
        {label: "Department", key: "department"}, 
        {label: "Region", key: "location"}, 
        {label: "Functionality", key: "functionality"}, 
        {label: "Employee", key: "employee"}, 
        {label: "OPEN", key: "open"}, 
        {label: "Insurance Card", key: "hasInsuranceCard"}, 
        {label: "Registration Card", key: "hasRegistrationCard"}, 
        {label: "License Number", key: "licenseNumber"}, 
        {label: "VIN", key: "vin"}, 
        {label: "Year", key: "year"}, 
        {label: "Make", key: "make"}, 
        {label: "Model", key: "model"}, 
        {label: "Status", key: "status"}, 
        {label: "Creator", key: "creator"}, 
        {label: "Date Created", key: "dateCreated", type: "date"}, 
        {label: "Updater", key: "updater"}, 
        {label: "Date Updated", key: "dateUpdated", type: "date"}, 
        {label: "Background", key: "background"}, 
    ];
    const defaultFilter = Object.fromEntries(dataFrame.map(item => [item.key, ""]));
    //--------------------------------------------------------------------------------------------
    // if(isDevMode) console.log("all");
    //--------------------------------------------------------------------------------------------
    const setShowLoader = useMyStore(state => state.setShowLoader);
    const user = useMyStore(state => state.user);
    const fleets = useMyStore(state => state.fleets);
    const setFleets = useMyStore(state => state.setFleets);
    const fleetDetails = useMyStore(state => state.fleets);
    const userNames = useMyStore(state => state.userNames);
    const setUserNames = useMyStore(state => state.setUserNames);
    //--------------------------------------------------------------------------------------------
    const history = useHistory();
    const path = history.location.pathname + (history.location.hash ?? "");
    const path1 = decodeURIComponent(path.split("/")[1] ?? ""); // title
    const path2 = decodeURIComponent(path.split("/")[2] ?? ""); // hash | pathKey
    const path3 = decodeURIComponent(path.split("/")[3] ?? "");
    //--------------------------------------------------------------------------------------------
    const [updateDateTime, setUpdateDateTime] = useState({
        "Fleets": fleets.updatedAt === null?getTimeStamp():fleets.updatedAt, 
        "FleetDetails": fleetDetails.updatedAt === null?getTimeStamp():fleetDetails.updatedAt,
        "userNames": userNames.updatedAt === null?getTimeStamp():userNames.updatedAt, 
    });
    //--------------------------------------------------------------------------------------------
    const [showLoading, setShowLoading] = useState(false);
    const [curFilter, setFilter] = useState(defaultFilter);
    const [filterWords, setFilterWords] = useState("");
    const [currentPage, setCurrentPage] = useState(1);
    const [itemsPerPage, setItemsPerPage] = useState(10);
    //--------------------------------------------------------------------------------------------
    const indexOfLastItem = currentPage * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;
    const fleetsExtended = fleets.data.map(uu => {
        const updatedFleetDetails = fleetDetails[uu.truckNumber];
        return {
            ...uu,
            ...(updatedFleetDetails ? updatedFleetDetails : {}),
            hasInsuranceCard: uu.insuranceCard ? "Yes" : "No",
            hasRegistrationCard: uu.registrationCard ? "Yes" : "No",
        };
    });
    const filteredFleets = fleetsExtended.filter(u => {
        // Ensure all fields required for filtering are present
        const truckNumber = u.truckNumber?.toLowerCase() ?? "";
        const department = u.department ?? "";
        const location = u.location ?? "";
        const functionality = u.functionality?.toLowerCase() ?? "";
        const employee = u.employee ?? "";
        const open = u.open ?? "";
        const hasInsuranceCard = u.hasInsuranceCard ?? "";
        const hasRegistrationCard = u.hasRegistrationCard ?? "";
        const licenseNumber = u.licenseNumber?.toLowerCase() ?? "";
        const vin = u.vin?.toLowerCase() ?? "";
        const year = u.year?.toLowerCase() ?? "";
        const make = u.make?.toLowerCase() ?? "";
        const model = u.model?.toLowerCase() ?? "";
        const creator = u.creator?.replace(/ {2}/g, " ") ?? "";
        const updater = u.updater?.replace(/ {2}/g, " ") ?? "";
        const background = u.background?.toLowerCase() ?? "";

        return (
            (curFilter.truckNumber ? truckNumber.includes(curFilter.truckNumber) : true) &&
            (curFilter.department ? department === curFilter.department : true) &&
            (curFilter.location ? location === curFilter.location : true) &&
            (curFilter.functionality ? functionality.includes(curFilter.functionality) : true) &&
            (curFilter.employee ? employee === curFilter.employee : true) &&
            (curFilter.open ? open === curFilter.open : true) &&
            (curFilter.hasInsuranceCard ? hasInsuranceCard === curFilter.hasInsuranceCard : true) &&
            (curFilter.hasRegistrationCard ? hasRegistrationCard === curFilter.hasRegistrationCard : true) &&
            (curFilter.licenseNumber ? licenseNumber.includes(curFilter.licenseNumber) : true) &&
            (curFilter.vin ? vin.includes(curFilter.vin) : true) &&
            (curFilter.year ? year.includes(curFilter.year) : true) &&
            (curFilter.make ? make.includes(curFilter.make) : true) &&
            (curFilter.model ? model.includes(curFilter.model) : true) &&
            (curFilter.creator ? creator === curFilter.creator : true) &&
            (u.dateCreated && curFilter.createdMin ? u.dateCreated >= curFilter.createdMin : true) &&
            (u.dateCreated && curFilter.createdMax ? u.dateCreated <= curFilter.createdMax : true) &&
            (curFilter.updater ? updater === curFilter.updater : true) &&
            (u.dateUpdated && curFilter.updatedMin ? u.dateUpdated >= curFilter.updatedMin : true) &&
            (u.dateUpdated && curFilter.updatedMax ? u.dateUpdated <= curFilter.updatedMax : true) &&
            (curFilter.background ? background.includes(curFilter.background) : true) &&
            filterWords
                .toLowerCase()
                .split(" ")
                .map(f => JSON.stringify(Object.values(u)).toLowerCase().includes(f))
                .reduce(boolAndReducer, true)
        );
    });
    const currentFleets = filteredFleets.slice(indexOfFirstItem, indexOfLastItem);
    const pageNumbers = Array.from({length: Math.ceil(filteredFleets.length / itemsPerPage)}, (_, i) => (i + 1));
    //--------------------------------------------------------------------------------------------
    const deleteFleet = async e => {
        if(window.confirm("Are you sure to delete this fleet?")){
            const formData = new MyFormData();
            formData.append("truckNumber", e.currentTarget.id);
            //---------------------------------------------
            setShowLoader(true);
            const res = await myAxios("fleet/deleteFleet.php", formData);
            setShowLoader(false);
            if(!res) return;
            //---------------------------------------------
            setFleets(res.data);
            history.replace(`/${path1}`);
            scroll(null);
        }
    }
    const handleSubmit = async e => {
        e.preventDefault();
        const formData = new MyFormData(e.currentTarget);
        //------------------------
        setShowLoader(true);
        const res = await myAxios(formData.get("url"), formData);
        setShowLoader(false);
        if(!res) return;
        //------------------------
        setFleets(res.data);
        history.push(`/${path1}`);
    }
    const editFleet = () => {
        history.push(`/${path1}/${path2}/Edit`);
    }
    const childRow = e => {
        if(user.fleets !== "no"){
            if(path2 !== e.currentTarget.id){
                history.push(`/${path1}/${e.currentTarget.id}`);
                scroll(e.currentTarget.id);
            }else{
                history.push(`/${path1}`);
                scroll(null);
            }
        }
    }
    const handleSystemFilesInput = async (
        target, fileId, folderId, key, truckNumber
    ) => {
        const files = target.files;
        if(files.length === 0) return;
        if(fileId && !window.confirm(`Are you sure to overwrite the existing ${key} card?`)) return;
        const formData = new MyFormData();
        formData.append("id", fileId?fileId:"");
        formData.append("folderId", folderId);
        formData.append("key", key);
        formData.append("truckNumber", truckNumber);
        for(let file of files){
            formData.append("files[]", file);
        }
        //------------------------
        setShowLoader(true);
        const res = await myAxios("fleet/createAttachment.php", formData);
        setShowLoader(false);
        if(!res) return;
        //------------------------
        setFleets(fleets.data.map(p => ({
            ...p, [key]:
            (p.truckNumber === truckNumber?
            res.data
            :p[key]
            )
        })));
        target.value = "";
    }
    const deleteFile = async(fileId, key, truckNumber) => {
        if(!window.confirm(`Are you sure to delete the existing ${key} card?`)) return;
        const formData = new MyFormData();
        formData.append("id", fileId);
        formData.append("key", key);
        formData.append("truckNumber", truckNumber);
        //---------------------------------------------------------------------
        setShowLoader(true);
        const res = await myAxios("fleet/deleteAttachment.php", formData);
        setShowLoader(false);
        if(!res) return;
        //---------------------------------------------------------------------
        setFleets(fleets.data.map(p => ({
            ...p, [key]:
            (p.truckNumber === truckNumber?
            ""
            :p[key]
            )
        })));
    }
    //--------------------------------------------------------------------------------------------
    useEffect(() => {
        if(updateDateTime["Fleets"] === fleets.updatedAt) return;
        let isMounted = true;
        const getData = async () => {
            //---------------------------------------------------------------------
            const formData = new MyFormData();
            formData.append("userNames", updateDateTime["userNames"] === userNames.updatedAt?"No":"Yes");
            setShowLoading(true);
            try {
                const res = await myAxios("fleet/readFleetsNew.php", formData);
                if (!isMounted) return;
                if (!res) return;

                setFleets(res.data.fleets, updateDateTime["Fleets"]);
                if(updateDateTime["userNames"] !== userNames.updatedAt) setUserNames(res.data.userNames, updateDateTime["Fleets"]);
                if(!res.data.fleets.find(u => path2 === u.truckNumber)){
                    if(pathKeys.includes(path2)) return;
                    history.replace(`/${path1}`);
                    return;
                }
            } finally {
                setShowLoading(false); // Ensure loading state is disabled in all cases
            }
        };
        getData();
        return () => {isMounted = false;}
    },[history, updateDateTime, path1, fleets, setFleets, setUserNames, userNames.updatedAt, path2, pathKeys, fleetDetails]); // itemsPerPage
    useEffect(() => {
        if (!pathKeys.includes(path2)) {
          const hashkeys = filteredFleets.map(v => v.truckNumber); // ✅ use filtered list
          const index = hashkeys.indexOf(path2);
          if (index > -1) {
            setCurrentPage(Math.ceil((index + 1) / itemsPerPage));
          }
          scroll(path2);
        }
      }, [path2, itemsPerPage, filteredFleets]);
    useEffect(() => {
        document.title = tabTitle;
        return () => {
            document.title = appTitle;
        };
    }, [tabTitle]);
    //--------------------------------------------------------------------------------------------
    return(
        <div className = "cssTab">
            <div className = "cssHeader" style = {{background: user.userTheme}}>
                <span>
                    <Resize/>
                    {tabTitle}
                    <button
                        type = "button"
                        data-toggle = "tooltip"
                        title = {`Refreshed on ${Object.values(updateDateTime)[0]}.`}
                        className = "btn btn-primary ml-3"
                        onClick = {() => {
                            const timeStamp = getTimeStamp();
                            setUpdateDateTime(Object.fromEntries(Object.keys(updateDateTime).map(key => [key, timeStamp])));
                        }}
                    >↻</button>
                </span>
                <span>
                    <input
                        id = "searchBar"
                        className = "form-control w-auto"
                        type = "text"
                        value = {filterWords}
                        onChange = {e => {
                            setFilterWords(e.currentTarget.value.toLowerCase());
                            setCurrentPage(1);
                        }}
                    />
                    <img alt = "" src = {magnifierImg}/>
                </span>
                <button type = "button" className = "headerButton" onClick = {() => {history.push(`/${path1}/Settings`);}}>Settings</button>
                {path2 === "Settings"?
                <Settings
                    tabTitle = {tabTitle}
                    closeIt = {() => history.push(`/${path1}`)}
                    history = {history}
                />
                :null}
                <button type = "button" className = "headerButton" onClick = {() => {history.push(`/${path1}/Yards`);}}>Yards</button>
                {path2 === "Yards"?
                <Yards
                    tabTitle = {tabTitle}
                    closeIt = {() => history.push(`/${path1}`)}
                    history = {history}
                />
                :null}
                <button type = "button" className = "headerButton" onClick = {() => {history.push(`/${path1}/Yard`);}}>Yard Itmes</button>
                {path2 === "Yard"?
                <Yard
                    tabTitle = {tabTitle}
                    closeIt = {() => history.push(`/${path1}`)}
                    history = {history}
                />
                :null}
                <button type = "button" className = "headerButton" onClick = {() => {history.push(`/${path1}/Inventory`);}}>Inventory</button>
                {path2 === "Inventory"?
                <Inventory
                    closeIt = {() => history.push(`/${path1}`)}
                />
                :null}
                <DataFilter
                    setCurrentPage = {setCurrentPage}
                    curFilter = {curFilter}
                    setFilter = {setFilter}
                    defaultFilter = {defaultFilter}
                    items = {fleetsExtended}
                    dataFrame = {dataFrame}
                    width = {"40rem"}
                />
                <Export
                    filteredFleets = {filteredFleets}
                />
                <button
                    type = "button"
                    className = "headerButton" 
                    onClick = {() => {history.push(`/${path1}/Add`);}}
                >
                    Add
                </button>
                {path2 === "Add"?
                <FleetForm
                    keyword = "Add"
                    handleSubmit = {handleSubmit}
                    closeIt = {() => history.push(`/${path1}`)}
                    shoulDisable = {false}
                    postUrl = "fleet/createFleet.php"
                    users = {userNames.data}
                />
                :null}
            </div>
            <div className = "cssContent pb10">
                {showLoading?<div className = "cssLoading">Loading...</div>:
                !currentFleets.length?<div className = "cssLoading">Empty</div>:
                <div className = "table-fixed">
                    <table className = "table">
                        <thead className = "noTableTopBorder">
                            <tr>
                                <th></th>
                                <th>Truck #</th>
                                <th>Department</th>
                                <th>Region</th>
                                <th>Functionality</th>
                                <th>Employee</th>
                                <th>OPEN</th>
                                <th>Type</th>
                                <th>Insurance Card</th>
                                <th>Registration Card</th>
                            </tr>
                        </thead>
                        <tbody>
                            {currentFleets.map((fleet, key) =>
                            <Fragment key = {key}>
                            <tr>
                                <td><button id = {fleet.truckNumber} onClick = {childRow} className = {(path2 === fleet.truckNumber?"showMinus":"showPlus") + " childRow"}></button></td>
                                <td>{fleet.truckNumber}</td>
                                <td>{fleet.department}</td>
                                <td>{fleet.location}</td>
                                <td>{fleet.functionality}</td>
                                <td>
                                    {fleet.employee?
                                    <UserInfo 
                                        name = {fleet.employeeName}
                                        email = {fleet.employee}
                                    />
                                    :null}
                                </td>
                                <td>{fleet.open}</td>
                                <td>{fleet.type}</td>
                                <td
                                    className = "text-nowrap"
                                    onDragOver = {e => {
                                        e.stopPropagation();
                                        e.preventDefault();
                                    }}
                                    onDrop = {async e => {
                                        e.preventDefault();
                                        e.stopPropagation();
                                        // **** create new file(s) ****
                                        handleSystemFilesInput(e.dataTransfer, fleet.insuranceCard, getDriveFolderId("insuranceCard"), "insuranceCard", fleet.truckNumber);
                                    }}
                                >
                                    {fleet.insuranceCard?<>
                                    <a
                                        className = "btn btn-success mr-3"
                                        href = {`https://drive.google.com/uc?export=download&id=${fleet.insuranceCard}`}
                                        target = "_blank"
                                        rel = "noreferrer"
                                    >
                                        <Download/>
                                    </a>
                                    {user.fleets === "yes"?
                                    <button
                                        className = "btn btn-danger mr-3"
                                        type = "button"
                                        onClick = {() => deleteFile(fleet.insuranceCard, "insuranceCard", fleet.truckNumber)}
                                    >
                                    X
                                    </button>
                                    :<></>}
                                    </>
                                    :null}
                                    {user.fleets === "yes"?
                                    <>
                                    <button
                                        className = "mb-0 btn btn-primary"
                                        type = "button"
                                        onClick = {e => e.currentTarget.nextElementSibling.click()}
                                    >
                                        <Upload/>
                                    </button>
                                    <input 
                                        className = "nodisplay"
                                        type = "file"
                                        onChange = {e => handleSystemFilesInput(e.currentTarget, fleet.insuranceCard, getDriveFolderId("insuranceCard"), "insuranceCard", fleet.truckNumber)}
                                    />
                                    </>
                                    :<></>}
                                </td>
                                <td
                                    onDragOver = {e => {
                                        e.stopPropagation();
                                        e.preventDefault();
                                    }}
                                    onDrop = {async e => {
                                        e.preventDefault();
                                        e.stopPropagation();
                                        // **** create new file(s) ****
                                        handleSystemFilesInput(e.dataTransfer, fleet.registrationCard, getDriveFolderId("registrationCard"), "registrationCard", fleet.truckNumber);
                                    }}
                                >
                                    {fleet.registrationCard?
                                    <>
                                    <a
                                        className = "btn btn-success mr-3"
                                        href = {`https://drive.google.com/uc?export=download&id=${fleet.registrationCard}`}
                                        target = "_blank"
                                        rel = "noreferrer"
                                    >
                                        <Download/>
                                    </a>
                                    {user.fleets === "yes"?
                                    <button
                                        className = "btn btn-danger mr-3"
                                        type = "button"
                                        onClick = {() => deleteFile(fleet.registrationCard, "registrationCard", fleet.truckNumber)}
                                    >
                                    X
                                    </button>
                                    :<></>}
                                    </>
                                    :null}
                                    {user.fleets === "yes"?
                                    <>
                                    <button
                                        className = "mb-0 btn btn-primary"
                                        type = "button"
                                        onClick = {e => {e.currentTarget.nextElementSibling.click()}}
                                    >
                                        <Upload/>
                                    </button>
                                    <input
                                        className = "nodisplay"
                                        type = "file"
                                        onChange = {e => handleSystemFilesInput(e.currentTarget, fleet.registrationCard, getDriveFolderId("registrationCard"), "registrationCard", fleet.truckNumber)}
                                    />
                                    </>
                                    :<></>}
                                </td>
                            </tr>
                            <tr>
                                <td className = "noborder" colSpan = {100}>
                                <TransitionWidthHeight 
                                    classNames = "cssTDTransition"
                                    In = {path2 ===  fleet.truckNumber}
                                >
                                    <Detail
                                        updateDateTime = {updateDateTime}
                                        tabTitle = {tabTitle}
                                        history = {history}
                                        path1 = {path1}
                                        path2 = {path2}
                                        path3 = {path3}
                                        fleet = {fleet}
                                        deleteFleet = {deleteFleet}
                                        editFleet = {editFleet}
                                        handleSubmit = {handleSubmit}
                                        setFleetList = {setFleets}
                                        trucksMap = {Object.fromEntries(fleets.data.filter(thisFleet => thisFleet.truckNumber !== fleet.truckNumber).map(thisFleet => [thisFleet.truckNumber, JSON.parse(thisFleet.inventory || "{}")]))}
                                    />
                                    </TransitionWidthHeight>
                                </td>
                            </tr>
                            </Fragment>)}
                        </tbody>
                    </table>
                </div>}
                {!showLoading && filteredFleets.length?
                <Footer
                    length = {filteredFleets.length}
                    pageNumbers = {pageNumbers}

                    currentPage = {currentPage}
                    setCurrentPage = {setCurrentPage}
                    itemsPerPage = {itemsPerPage}
                    setItemsPerPage = {setItemsPerPage}

                    paginateAction = {() => history.push(`/${path1}`)}
                />
                :null}
            </div>
        </div>
    )
}